<h1 class="c11n-text-xl-headline c11n-space-stack-3x">{{ frmcRemoveAccessSelectUser.heading }}</h1>

@if (isInternal) {
    <c11n-internal-callout class="c11n-space-stack-3x">
        <p class="c11n-text-md c11n-link--reinforced">
            {{ infowaveBoxContents[0] }} <a
                [href]="infoWaveUrl"
                [variant]="'secondary-reinforced'"
                c11n-link
                class="c11n-link pointer"
                tabindex="0"
                target="_blank">Infowave</a>
            {{ infowaveBoxContents[1] }}
        </p>
    </c11n-internal-callout>
}

<div class="c11n-space-stack-3x custom-radio-style">
    <c11n-radio-group
            [formGroup]="selectUserFormGroup"
            [groupId]="radioGroupId"
            [hideLegend]="true"
            [legendText]="content.removeAccessFlow.selectUser.title"
            [variant]="'tiles'"
    >
        <c11n-radio
                *ngFor="let user of users$ | async; index as i"
                [focusLabel]="false"
                [labelText]="constructUserName(user)"
        >
            <input
                    (change)="onUserSelect(user)"
                    [attr.user-access-level]="user.accessLevel"
                    [formControlName]="selectUserFormControlName"
                    [name]="selectUserFormControlName"
                    [value]="user"
                    c11nRadioInput
                    type="radio"
            />
        </c11n-radio>
    </c11n-radio-group>

    @if (showSelectionError) {
    <div #selectionError class="selection-error c11n-space-stack-3x" data-cy="selection-error" role="alert">
        <c11n-icon [name]="'error'" [size]="'small'"></c11n-icon>
        <strong>Error:</strong> Please select one person from the list
    </div>
}
</div>

